import { motion } from "framer-motion";
import { Sparkles } from "lucide-react";

const MagicLoader = ({ text = "Creating magic..." }) => (
  <div className="flex flex-col items-center gap-4">
    <motion.div
      animate={{ rotate: 360 }}
      transition={{ duration: 2, repeat: Infinity, ease: "linear" }}
      className="w-12 h-12 rounded-full bg-gradient-to-r from-violet-500 to-amber-500 flex items-center justify-center"
    >
      <Sparkles className="w-6 h-6 text-white" />
    </motion.div>
    <p className="text-slate-600 font-medium">{text}</p>
  </div>
);

export default MagicLoader;
